import api from "Architecture/api";

//Modules

export const createModule = (body) => {
    return api.post(`/module`, body);
};

export const getModuleList = (body) => {
    return api.get(`/module`, body);
};

export const updateModule = (body) => {
    return api.put(`/module`, body);
};

// Groups

export const createGroup = (body) => {
    return api.post(`/group`, body);
};

export const getGroupList = (body) => {
    return api.get(`/group`, body);
};

export const updateGroup = (body) => {
    return api.put(`/group`, body);
};


// Designations

export const createDesignation = (body) => {
    return api.post(`/designation`, body);
};

export const getDesignationList = (body) => {
    return api.get(`/designation`, body);
};

export const updateDesignation = (body) => {
    return api.put(`/designation`, body);
};

// Department

export const createDepartment = (body) => {
    return api.post(`/department`, body);
};

export const getDepartmentList = () => {
    return api.get(`/department`);
};


export const updateDepartment = (body) => {
    return api.put(`/department`, body);
};

// user types

export const getUserTypes = () => {
    return api.get(`/user-types`);
};

//Permissions

export const getGroupPermissionsList = (body) => {
    return api.get(`/permisions`, body);
};

export const savePermissions = (body) => {
    return api.post(`/group/assign-module`, body);
};


// Article Management

export const createArticle = (body) => {
    return api.post(`/article`, body);
};

export const getArticleList = () => {
    return api.get(`/article`);
};

export const updateArticle = (body) => {
    return api.put(`/article`, body);
};

export const getArticle = ({ slug }) => {
    return api.get(`/article/${slug}`);
};

export const deleteArticle = ({ id }) => {
    return api.delete(`/article/${id}`);
};

export const uploadFile = async (file) => {
    try {
        const filename = `${Date.now() + '-' + Date.now()}-${file.name}`;
        // Read the file as ArrayBuffer
        const arrayBuffer = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsArrayBuffer(file);
        });

        // Get presigned URL
        const { data } = await api.post('/signed-url', {
            files: [
                {
                    fileName: filename,
                    folderName: "profile"
                }
            ],
            type: "put"
        });

        if (!data.success) throw new Error('Failed to get presigned URL');

        const presignedData = data.data.signedUrl ?? data.data[0].signedUrl;
        const uploadResponse = await fetch(presignedData, {
            method: 'PUT',
            body: arrayBuffer,
            headers: { "Content-Type": file.type }, // Set content type based on file type
        });
        if (!uploadResponse.ok) throw new Error('Failed to upload file');
        return { filename: 'profile/' + filename, success: true, message: 'Upload file successfully' };
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const createEntity = (body) => {
    return api.post(`/entity`, body);
};

export const getEntityList = (body) => {
    return api.get(`/entity`, body);
};

export const updateEntity = (body) => {
    return api.put(`/entity`, body);
};

export const createBrand = (body) => {
    return api.post(`/brand`, body);
};

export const updateBrand = (body) => {
    return api.put(`/brand`, body);
};

export const getBrandList = (body = {}) => {
    // Construct query string from body object
    const query = new URLSearchParams(body).toString();
    // Send GET request with query string
    return api.get(`/brand${query ? `?${query}` : ''}`);
};

export const createProductType = (body) => {
    return api.post(`/product-type`, body);
};

export const updateProductType = (body) => {
    return api.put(`/product-type`, body);
};

export const getProductTypeList = (body = {}) => {
    // Construct query string from body object
    const query = new URLSearchParams(body).toString();
    // Send GET request with query string
    return api.get(`/product-type${query ? `?${query}` : ''}`);
};

export const getProductsList = (body = {}) => {

    console.log('Body:', body); 
    const query = new URLSearchParams(body).toString();
    console.log('Query:', query);
    // Send GET request with query string
    return api.get(`/products${query ? `?${query}` : ''}`);
};

export const createProduct = (body) => {
    return api.post(`/product`, body);
};

export const updateProduct = (body) => {
    return api.put(`/product`, body);
};
